import { useContext } from 'react';
import { TenantContext } from '../../context/tenant-context';
import axios, { AxiosRequestConfig } from 'axios';

export const useCustomerYorentClient = () => {
  const { tenant, contextPath } = useContext(TenantContext);

  function login(email: string, pwd: string, isAsync: boolean = false): Promise<{ status: number; msg: string }> {
    const form = new FormData();
    form.append('email', email);
    form.append('password', pwd);
    form.append('is_ajax_request', isAsync ? 'yes' : 'no');
    form.append('btn_login', 'Submit');

    const config = {
      method: 'post',
      url: `${contextPath}user/login`,
      headers: {
        'X-Tenant': tenant,
        'Legacy-Route': true,
      },
      data: form,
    };
    return handleRequest(config);
  }

  function signUp(
    username: string,
    email: string,
    pwd: string,
    phone: string,
    gtoken: string,
    isAsync: boolean = false,
  ): Promise<{ status: number; msg: string }> {
    const form = new FormData();
    form.append('user_name', username);
    form.append('user_email', email);
    form.append('user_phone', phone);
    form.append('user_password', pwd);
    form.append('is_ajax_request', isAsync ? 'yes' : 'no');
    form.append('btn_signup', 'Submit');
    form.append('g-recaptcha-response', gtoken);

    const config = {
      method: 'post',
      url: `${contextPath}user/signup`,
      headers: {
        'X-Tenant': tenant,
        'Legacy-Route': true,
      },
      data: form,
    };
    return handleRequest(config);
  }

  function guestLogin(
    username: string,
    email: string,
    gtoken: string,
    phone?: string,
    isAsync: boolean = false,
  ): Promise<{ status: number; msg: string }> {
    const form = new FormData();
    form.append('user_name', username);
    form.append('user_email', email);
    if (phone) {
      form.append('user_phone', phone);
    }
    form.append('is_ajax_request', isAsync ? 'yes' : 'no');
    form.append('g-recaptcha-response', gtoken);

    const config = {
      method: 'post',
      url: `${contextPath}user/guest_login`,
      headers: {
        'X-Tenant': tenant,
        'Legacy-Route': true,
      },
      data: form,
    };
    return handleRequest(config);
  }

  function forgotPassword(email: string, isAsync: boolean = false): Promise<{ status: number; msg: string }> {
    const form = new FormData();
    form.append('user_email', email);
    form.append('is_ajax_request', isAsync ? 'yes' : 'no');

    const config = {
      method: 'post',
      url: `${contextPath}user/forgot_password`,
      headers: {
        'X-Tenant': tenant,
        'Legacy-Route': true,
      },
      data: form,
    };
    return handleRequest(config);
  }

  async function refreshCartProductCount(): Promise<void> {
    const config = {
      method: 'get',
      url: `${contextPath}cart/refreshProductCount`,
      headers: {
        'X-Tenant': tenant,
        'Legacy-Route': true,
      },
    };
    await handleRequest(config);
  }

  return {
    login,
    signUp,
    guestLogin,
    forgotPassword,
    refreshCartProductCount,
  };
};

async function handleRequest<T>(req: AxiosRequestConfig): Promise<T> {
  const response = await axios(req);
  return response.data as T;
}
